import styled from "styled-components";
import colours from "styles/colours";
import fonts, { fontWeights } from "styles/fonts";

export const Header = styled.h2`
  && {
    color: ${colours.elexonBlue};
    margin: 0;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 30px;
`;

export const ButtonDiv = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const Content = styled.div`
  padding-left: 1em;
  padding-right: 1em;
  font-size: ${fonts.smallMedium};
`;

export const DescriptionSections = styled.dl`
  dt {
    font-weight: ${fontWeights.bold};
    margin-top: 2rem;
  }
  dd + dd {
    margin-top: 1rem;
  }
  ol {
    margin-top: 0;
  }
`;
